module.exports = __webpack_public_path__ + "assets/img/user__easyico.6267a09c.png";